import moment from "moment";
import { useTranslation } from "react-i18next";

export default function useInteractionTypes() {
  const { t } = useTranslation();
  return {
    0: {
      id: "survey",
      title: t("interactions.survey.use"),
      menuOptions: [
        {
          id: "send",
          title: t("interactions.survey.send"),
          subTitle: t("interactions.survey.sendHelp", {
            time: moment().format("HH:mm"),
          }),
        },
        {
          id: "schedule",
          title: t("interactions.survey.schedule"),
          subTitle: t("interactions.survey.scheduleHelp"),
        },
        {
          id: "install",
          title: t("interactions.survey.install"),
          subTitle: t("interactions.survey.installHelp"),
        },
        {
          id: "previewOnMyPhone",
          title: t("interactions.survey.preview"),
          subTitle: t("interactions.survey.previewHelp"),
        },
      ],
    },
    1: {
      id: "button",
      title: t("interactions.button.use"),
      menuOptions: [
        {
          id: "install",
          title: t("interactions.button.install"),
          subTitle: t("interactions.button.installHelp"),
        },
        {
          id: "schedule",
          title: t("interactions.button.schedule"),
          subTitle: t("interactions.button.scheduleHelp"),
        },
        {
          id: "previewOnMyPhone",
          title: t("interactions.button.preview"),
          subTitle: t("interactions.button.previewHelp"),
        },
      ],
    },
    2: {
      id: "applet",
      title: t("interactions.app.use"),
      menuOptions: [
        {
          id: "install",
          title: t("interactions.app.install"),
          subTitle: t("interactions.app.installHelp"),
        },
        {
          id: "schedule",
          title: t("interactions.app.schedule"),
          subTitle: t("interactions.app.scheduleHelp"),
        },
        {
          id: "previewOnMyPhone",
          title: t("interactions.app.preview"),
          subTitle: t("interactions.app.previewHelp"),
        },
      ],
    },
  };
}
